import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

export const Wrapper = styled.div<{path: string, bgPosition?: string, textAlign: string, order: number, bgSizeMobile?: string, bgSize?: string}>`
    width: 435px;
    height: 468px;
    flex-direction: column;
    background-color:  rgba(255, 255, 255, .05);
    background-size: ${p => p.bgSize || 'auto'};
    background-image: url('${p => p.path}');
    background-repeat: no-repeat;
    background-position: ${p => p.bgPosition};
    border-radius: ${BorderRadius.OuterBlockRadius};
    padding: 44px 50px 31px 53px;
    justify-content: ${p => p.textAlign};
    color: ${COLORS.TextWhite};
    row-gap: 10px;

    @media (max-width: ${breakPoints.desktop}) {
       padding: 31px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
       padding: 40px 24px 46px 31px;
       height: 437px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 339px;
        height: 340px;
        order: ${p => p.order};
        padding: 24px;
        background-size: ${p => p.bgSizeMobile || 'auto'};
    }

    @media (max-width: ${breakPoints.mobile}) {
       max-width: 100%;
       height: 315px;
    }
`;

export const TitleCard = styled.div`
    ${FONTS.H3};

    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.H4};
    }
`;

export const Text = styled.div`
    ${FONTS.S};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.XS};
    }
`;
